import classnames from 'classnames';
import React from 'react';

import Icon from 'dpl/common/components/Icon';

interface CheckoutNextStepProps {
  text: string;
  className?: string;
}

export default function CheckoutNextStep({
  text,
  className = ''
}: CheckoutNextStepProps) {
  return (
    <div
      className={classnames('flex gap-8 font-14', className)}
      data-test-id="checkout-next-step"
    >
      <Icon
        className="flex-none mt1"
        name="gooddogavatar"
        width="18px"
        height="18px"
      />
      <p>
        <span className="fw-medium">Next:</span> {text}
      </p>
    </div>
  );
}
